function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (tobj) {
  var html = "\n    <div class=\"saitoa trade-overlay\">\n      <div class=\"h2\">You ".concat(tobj.accepting_trade ? 'Accept' : 'Want', ":</div>\n      <div class=\"trade_overlay_offers\">");
  var num_cards_in_play = 0;
  var _iterator = _createForOfIteratorHelper(tobj.resources),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var r = _step.value;
      html += "<div id=\"want_".concat(r, "\" class=\"trade_area select ").concat(r, "\">\n          <div class=\"trade_count_arrow trade_count_up can_select\"></div>  \n          <div class=\"trade_count_number\" data-count=\"").concat(tobj.get[r], "\">").concat(tobj.get[r] > 0 ? tobj.get[r] : '', "</div> \n          <div class=\"trade_count_arrow trade_count_down").concat(tobj.get[r] > 0 ? ' can_select' : '', "\"></div>\n        </div>");
      num_cards_in_play += tobj.get[r];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  html += "</div>\n      <div class=\"h2\">You ".concat(tobj.accepting_trade ? 'Give' : 'Offer', ":</div>\n      <div class=\"trade_overlay_offers\">");
  var valid_trade = true;
  var _iterator2 = _createForOfIteratorHelper(tobj.resources),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _r = _step2.value;
      if (tobj.give[_r] > tobj.mod.countResource(tobj.mod.game.player, _r)) {
        valid_trade = false;
      }
      html += "<div id=\"offer_".concat(_r, "\" class=\"trade_area select ").concat(_r, " \n\t\t\t\t\t").concat(tobj.give[_r] > tobj.mod.countResource(tobj.mod.game.player, _r) ? ' invalid_offer' : '', "\">\n            <div class=\"trade_count_arrow trade_count_up ").concat(tobj.give[_r] < tobj.mod.countResource(tobj.mod.game.player, _r) ? ' can_select' : '', "\"></div>  \n            <div class=\"trade_count_number\" data-count=\"").concat(tobj.give[_r], "\">").concat(tobj.give[_r] > 0 ? tobj.give[_r] : '', "</div> \n            <div class=\"trade_count_arrow trade_count_down").concat(tobj.give[_r] > 0 ? ' can_select' : '', "\"></div>\n          </div>");
      num_cards_in_play += tobj.give[_r];
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  html += "</div>\n\n      <div class=\"trade_overlay_buttons\">\n      \t<div id=\"trade_overlay_cancel_button\" class=\"trade_overlay_button valid_trade\">".concat(tobj.accepting_trade ? 'Reject' : 'Cancel', " Offer</div>\n        <div id=\"trade_overlay_broadcast_button\" class=\"trade_overlay_button ").concat(valid_trade && num_cards_in_play > 0 ? 'valid_trade' : 'noselect', "\">").concat(tobj.accepting_trade && valid_trade ? 'Accept' : 'Broadcast', " Offer</div>\n      </div>\n\n    </div>\n  ");
  return html;
};